const MAX_CONVERSATION_TITLE_LENGTH = 80;

export function deriveConversationTitle(prompt: string): string | null {
  const compact = prompt.replace(/\s+/g, ' ').trim();
  if (!compact) return null;

  if (compact.length <= MAX_CONVERSATION_TITLE_LENGTH) {
    return compact;
  }

  return `${compact.slice(0, MAX_CONVERSATION_TITLE_LENGTH - 3)}...`;
}
